export enum ErrorCode {
  GENERATE_LIMIT = 'server.task.credits_insufficient',
  UPSCALE_LIMIT = 'server.task.credits_insufficient',
  REALTIME_LIMIT = 'server.task.credits_insufficient',
  INVITATION_CODE_INVALID = '10008',
  INVITATION_CODE_USED = '10009',
  SERVER_UPSCALE_SCALE_ERROR = 'server.task.upscale_scale_error',
  CAMPAIGN_SYSTEM_ERROR = 'campaign.system_error',
  CAMPAIGN_USER_AUTH_ERROR = 'campaign.user_auth_error',
  CAMPAIGN_PARAM_ERROR = 'campaign.param_error',
  CAMPAIGN_QUERY_ERROR = 'campaign.query_error',
  CAMPAIGN_CAMPAIGN_NOT_COMPLETED = 'campaign.campaign_not_completed',
  CAMPAIGN_REWARD_ALREADY_CLAIMED = 'campaign.reward_already_claimed',
  CAMPAIGN_COUPON_NOT_AVAILABLE = 'campaign.coupon_not_available',
  CAMPAIGN_USE_COUPON = 'campaign.use_coupon',
  CAMPAIGN_ASSIGN_COUPON = 'campaign.assign_coupon',
  USER_GOOGLE_AUTH_FAIL = 'user.google_auth_fail',
  USER_NOT_SUPPORT_LOGIN_TYPE = 'user.not_support_login_type',
  USER_SYSTEM_ERROR = 'user.system_error',
  USER_LOGIN_ERROR = 'user.login_error'
}

export const SimilarErrorCode = {
  NO_SIMILAR_IMAGES_FOUND: '10001',
  ERROR_DURING_FETCHING_IMAGES: '10002',
  ERROR_LOADING_MORE_DETAIL_IMAGE: '10003'
}

export interface ErrorData {}

export interface LimitErrorData extends ErrorData {
  usage: number
  limit: number
  availableTime?: string
}

export const ErrorCodeI18nKeysMap: Record<string, string> = {
  [ErrorCode.SERVER_UPSCALE_SCALE_ERROR]: 'upscaleScaleError',
  [ErrorCode.CAMPAIGN_SYSTEM_ERROR]: 'campaignSystemError',
  [ErrorCode.CAMPAIGN_USER_AUTH_ERROR]: 'campaignUserAuthError',
  [ErrorCode.CAMPAIGN_PARAM_ERROR]: 'campaignParamError',
  [ErrorCode.CAMPAIGN_QUERY_ERROR]: 'campaignQueryError',
  [ErrorCode.CAMPAIGN_CAMPAIGN_NOT_COMPLETED]: 'campaignNotCompleted',
  [ErrorCode.CAMPAIGN_REWARD_ALREADY_CLAIMED]: 'campaignRewardAlreadyClaimed',
  [ErrorCode.CAMPAIGN_COUPON_NOT_AVAILABLE]: 'campaignCouponNotAvailable',
  [ErrorCode.CAMPAIGN_USE_COUPON]: 'campaignUseCoupon',
  [ErrorCode.CAMPAIGN_ASSIGN_COUPON]: 'campaignAssignCoupon',
  [ErrorCode.USER_GOOGLE_AUTH_FAIL]: 'userGoogleAuthFail',
  [ErrorCode.USER_NOT_SUPPORT_LOGIN_TYPE]: 'userNotSupportLoginType',
  [ErrorCode.USER_SYSTEM_ERROR]: 'userSystemError',
  [ErrorCode.USER_LOGIN_ERROR]: 'userLoginError'
}
